if (!customElements.get('localization-form')) {
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.inputs = this.form
        ? this.form.querySelectorAll('select[name="locale_code"], select[name="country_code"]')
        : [];

      this.debouncedOnSubmit = debounce((event) => {
        this.onSubmitHandler(event);
      }, 200);

      this.inputs.forEach((item) =>
        item.addEventListener('change', this.debouncedOnSubmit.bind(this))
      );

      this.currencyDisclosure = null;
      this.currencyToggle = null;
      this.currencyList = null;
      this.currencyOptions = [];
      this.currencySelect = null;
      this.currencyLabelEl = null;
      this.currencyFlagEl = null;

      this._onDocumentClick = null;
      this._onDocumentKeydown = null;

      this.setupCurrencyDisclosure();
    }

    disconnectedCallback() {
      document.removeEventListener('click', this._onDocumentClick);
      document.removeEventListener('keydown', this._onDocumentKeydown);
    }

    onSubmitHandler() {
      if (this.form) this.form.submit();
    }

    setupCurrencyDisclosure() {
      if (!this.form) return;

      const disclosure = this.querySelector('[data-currency-disclosure]');
      const currencySelect = this.form.querySelector('select.thb-currency-code');

      if (!disclosure || !currencySelect) return;

      this.currencyDisclosure = disclosure;
      this.currencySelect = currencySelect;
      this.currencyToggle = disclosure.querySelector('.currency-disclosure__toggle');
      this.currencyList = disclosure.querySelector('.currency-disclosure__list');
      this.currencyOptions = Array.from(
        disclosure.querySelectorAll('.currency-disclosure__option')
      );
      this.currencyLabelEl = disclosure.querySelector('.currency-disclosure__label');
      this.currencyFlagEl = this.currencyToggle?.querySelector('.fi');

      this.align = disclosure.dataset.align || "right";
      this.valign = disclosure.dataset.valign || "bottom";

      this.applyDisclosureAlignment();

      this.currencyToggle.addEventListener('click', (event) => {
        event.preventDefault();
        this.currencyDisclosure.classList.contains('is-open')
          ? this.closeCurrencyDisclosure()
          : this.openCurrencyDisclosure();
      });

      this._onDocumentClick = (event) => {
        if (!this.contains(event.target)) this.closeCurrencyDisclosure();
      };
      document.addEventListener('click', this._onDocumentClick);

      this._onDocumentKeydown = (event) => {
        if (event.key === 'Escape') {
          this.closeCurrencyDisclosure();
          this.currencyToggle.focus();
        }
      };
      document.addEventListener('keydown', this._onDocumentKeydown);

      this.currencyOptions.forEach((option) => {
        option.addEventListener('click', () => {
          const code = option.dataset.countryCode;
          if (!code) return;

          this.currencySelect.value = code;

          this.currencyOptions.forEach((o) =>
            o.classList.remove('currency-disclosure__option--active')
          );
          option.classList.add('currency-disclosure__option--active');

          const optionCurrency = option.querySelector('.currency-disclosure__option-currency');
          if (optionCurrency) {
            this.currencyLabelEl.textContent =
              optionCurrency.textContent.trim().split(' ')[0];
          }

          const optionFlag = option.querySelector('.fi');
          if (optionFlag && this.currencyFlagEl) {
            this.currencyFlagEl.className = optionFlag.className;
          }

          this.closeCurrencyDisclosure();

          this.currencySelect.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    }

    applyDisclosureAlignment() {
      if (!this.currencyList) return;

      this.currencyList.style.left = this.align === "left" ? "0" : "auto";
      this.currencyList.style.right = this.align === "right" ? "0" : "auto";

      if (this.valign === "top") {
        this.currencyList.style.top = "auto";
        this.currencyList.style.bottom = "calc(100% + 6px)";
      } else {
        this.currencyList.style.bottom = "auto";
        this.currencyList.style.top = "calc(100% + 6px)";
      }
    }

    openCurrencyDisclosure() {
      if (!this.currencyDisclosure) return;
      this.currencyDisclosure.classList.add('is-open');
      this.currencyList.hidden = false;
      this.currencyToggle.setAttribute('aria-expanded', 'true');
    }

    closeCurrencyDisclosure() {
      if (!this.currencyDisclosure) return;
      this.currencyDisclosure.classList.remove('is-open');
      this.currencyList.hidden = true;
      this.currencyToggle.setAttribute('aria-expanded', 'false');
    }
  }

  customElements.define('localization-form', LocalizationForm);
}
